import { render, staticRenderFns } from "./webAiVoiceInput.vue?vue&type=template&id=4bd9f3a7&scoped=true&"
import script from "./webAiVoiceInput.vue?vue&type=script&lang=js&"
export * from "./webAiVoiceInput.vue?vue&type=script&lang=js&"
import style0 from "./webAiVoiceInput.vue?vue&type=style&index=0&id=4bd9f3a7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9f3a7",
  null
  
)

export default component.exports